// extracted by mini-css-extract-plugin
module.exports = {"board":"Board_board__xtnRe","row":"Board_row__22fq5","cell":"Board_cell__3zmKG"};